import React from 'react'
import { Table } from 'react-bootstrap'
import { Badge } from 'reactstrap'

import { TOrder } from '../helpers'

type TAdditionalServicesTable = {
  order?: TOrder
}

const AdditionalServicesTable = (
  props: TAdditionalServicesTable,
): React.ReactElement => {
  const { order } = props

  return (
    <React.Fragment>
      <Table size="sm" striped bordered responsive>
        <tbody>
          <tr>
            <th>{i18n.t('service', 'Service')}</th>
            <th>{i18n.t('status', 'Status')} </th>
          </tr>

          {order &&
            order.additional_services &&
            order.additional_services.map((service, index) => (
              <tr key={index}>
                <td>{service.description}</td>
                <td>
                  <Badge color={service.active ? `success` : 'danger'}>
                    <i
                      className={`fas fa-${service.active ? 'check' : 'times'}`}
                    />
                  </Badge>
                  {service.name === 'COD' && (
                    <span className="ml-2">{`${order.cashondeliveryAmount} ${order.cashondeliveryCurrency}`}</span>
                  )}
                </td>
              </tr>
            ))}

          {}
        </tbody>
      </Table>
    </React.Fragment>
  )
}

export default AdditionalServicesTable
